import * as React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import  { FundiProfileDashboard,FundiProfileWallet,FundiProfileSubscription } from '../../blocks/fundi/FundiProfileWallet';
import FundiProfileSetting from '../../blocks/form/fundi/FundiProfileSetting';
import FundiAccountSetting from '../../blocks/form/fundi/FundiAccountSetting';
import {FundiPaymentSetting} from '../../blocks/form/fundi/FundiPaymentSetting';
import PaymentMethod from '../../element/card/PaymentMethod';
import { FundiIdUpload ,FundiCertiUpload} from '../../element/fileupload/fundi/FundiIdUpload';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

 const FundiProfileTabs = () => {
    
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ maxWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                     
                        sx={{
                           
                            borderColor: 'divider',
                            flexShrink: 0,
                            width: '356px',
                            height: 'auto',
                            backgroundColor: '#F4F4F4',
                            border: '0.5px solid #28A745',
                            margin:0,
                           
                            '& .MuiTabs-indicator': {
                                display: 'none',
                            },
                            '& .MuiTab-root.Mui-selected': {
                                borderLeft: '6px solid #28A745',
                            },
                        }}
                    >
                        <Tab label="Dashboard" {...a11yProps(0)} />
                        <Tab label="Wallet"  {...a11yProps(1)} />
                        <Tab label="Subscription Package"  {...a11yProps(2)} />
                        <Tab label="Identity Verification"  {...a11yProps(3)} />
                        <Tab label="Profile Settings" {...a11yProps(4)} />
                        <Tab label="Account Settings" {...a11yProps(4)} />
                        <Tab label="Payment Settings" {...a11yProps(4)} />

                    </Tabs>
                    <PaymentMethod />
                </Box>


                <Box sx={{ flexGrow: 1, height: '100%' }} >
                    <TabPanel value={value} index={0}>
                        <FundiProfileDashboard/>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <FundiProfileWallet/>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                    
                        <FundiProfileSubscription/>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <FundiIdUpload/>   
                        <FundiCertiUpload/>
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                    <FundiProfileSetting/> 
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                    <FundiAccountSetting/>
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                        <FundiPaymentSetting/>
                    </TabPanel>

                </Box>
            </Box>
        </Box>
    );
}
export default FundiProfileTabs;